/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeEvery, put, call } from 'redux-saga/effects';
import {
  BASIC_INFO,
  BASIC_INFORMATION,
  GET_TASKS_LIST,
  // GET_IRT_REPONSE,
  GET_IRT_REPONSE_FAIL,
  GET_IRT_REPONSE_SUCCESS,
  GET_QDR_REPONSE_FAIL,
  GET_QDR_REPONSE_SUCCESS,
  // GET_REPORT,
  GET_REPORT_IRT,
  GET_REPORT_QDR,
  GET_TASKS_FAIL,
  GET_TASKS_SUCCESS,
  // QUESTION_BANK,
  // QUESTION_CREATION,
  QUESTION_CREATION_CANCEL,
  QUESTION_CREATION_CHOOSE_BACK,
  QUESTION_CREATION_FINAL_CALL,
  QUESTION_CREATION_ONE,
  QUESTION_CREATION_SCREEN_BACK,
  QUESTION_CREATION_SCREEN_CANCEL,
  QUESTION_CREATION_SCREEN_CHANGE,
  QUESTION_CREATION_SCREEN_CHOOSE_ONLY_BACK,
  QUESTION_CREATION_TWO,
  SELECT_QUESTION_BANK,
  // SELECT_QUESTION_BANK_RESPONSE,
  SEND_FOR_REVIEW,
  GET_TASKS_DETAIL,
  GET_TASKS_DETAIL_SUCCESS,
  GET_TASKS_DETAIL_FAIL,
  DELETE_TASKS,
  APPROVE_TASKS,
  DELETE_TASKS_SUCCESS,
  DELETE_TASKS_FAIL,
  APPROVE_TASKS_SUCCESS,
  APPROVE_TASKS_FAIL,
  REVIEW_ALLDATA_SUCCESS,
  REVIEW_ALLDATA_FAIL,
  GET_REVIEW_ALL_DATA,
  GET_NEED_REVIEW_ALL_DATA,
  NEED_REVIEW_ALLDATA_SUCCESS,
  NEED_REVIEW_ALLDATA_FAIL,
  CHANGE_REVIEW_STATUS,
  CHANGE_REVIEW_STATUS_FAIL,
  CHANGE_REVIEW_STATUS_SUCCESS,
  GET_USER_LIST,
  GET_USER_LIST_SUCESS,
  GET_USER_LIST_FAIL,
  GET_USER_DETAIL,
  GET_USER_DETAIL_FAIL,
  GET_USER_DETAIL_SUCCESS,
  GET_USER_ROLES,
  GET_USER_ROLE_LIST,
  GET_USER_ROLES_SUCCESS,
  GET_USER_ROLES_FAIL,
  GET_USER_QUESTION_BANK,
  GET_USER_QUESTION_BANK_SUCCESS,
  GET_USER_QUESTION_BANK_FAIL,
  GET_ADD_USER,
  GET_ADD_USER_SUCCESS,
  GET_ADD_USER_FAIL,
  EDIT_USER_DETAIL,
  EDIT_USER_DETAIL_SUCCESS,
  EDIT_USER_DETAIL_FAIL,
  GET_ORGANISATION_LIST,
  GET_ORGANISATION_LIST_SUCCESS,
  GET_ORGANISATION_LIST_FAIL,
  GET_ORGANISATION_DETAIL,
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_SUCCESS,
  GET_CATEGORY_LIST_FAIL,
  GET_IDENTIFIER_LIST,
  GET_LOD_LIST,
  GET_SUBJECT_PIPELINE_LIST,
  GET_IDENTIFIER_LIST_SUCCESS,
  GET_IDENTIFIER_LIST_FAIL,
  GET_LOD_LIST_SUCCESS,
  GET_LOD_LIST_FAIL,
  GET_SUBJECT_PIPELINE_LIST_SUCCESS,
  GET_SUBJECT_PIPELINE_LIST_FAIL,
  GET_QUESTION_BANK_LIST,
  GET_QUESTION_BANK_LIST_SUCCESS,
  GET_QUESTION_BANK_LIST_FAIL,
  CREATE_TASK,
  CREATE_TASK_SUCCESS,
  CREATE_TASK_FAIL,
  GET_PRODUCT_TYPE,
  GET_PRODUCT_TYPE_SUCCESS,
  GET_PRODUCT_TYPE_FAIL,
  EDIT_TASK,
  EDIT_TASK_SUCCESS,
  EDIT_TASK_FAIL,
  // CREATE_TEST,
  // CREATE_TEST_SUCCESS,
  // CREATE_TEST_FAIL,
  GET_TASK_OF_USER,
  CREATE_TEST_BASIC_SETTING,
  CREATE_TEST_BASIC_SETTING_SUCCESS,
  CHANGE_ADD_TEST_SCREEN,
  CREATE_TEST_SECTION,
  PUBLISH_TEST,
  GET_TEST_LISTING_SUCCESS,
  GET_TEST_LISTING_FAIL,
  GET_TEST_LISTING,
  CHANGE_TEST_SCREEN,
  DELETE_TEST_SUCCESS,
  DELETE_TEST_FAIL,
  DELETE_TEST,
  UNPUBLISH_TEST_FAIL,
  UNPUBLISH_TEST_SUCCESS,
  UNPUBLISH_TEST,
  DUPLICATE_TEST_SUCCESS,
  DUPLICATE_TEST_FAIL,
  DUPLICATE_TEST,
  PRODUCT_TYPE,
  PRODUCT_TYPE_SUCCUSS,
  PRODUCT_TYPE_FAIL,
  GET_TEST_DETAILS,
  GET_TEST_DETAILS_SUCCESS,
  GET_TEST_DETAILS_FAIL,
  CREATE_TEST_SECTION_SUCCESS,
  CREATE_TEST_SECTION_FAIL,
  VALIDATE_SECTION_RULE_SUCCESS,
  VALIDATE_SECTION_RULE_FAIL,
  PUBLISH_TEST_SUCCESS,
  PUBLISH_TEST_FAIL,
  GET_REPLACE_QUESTION,
  GET_REPLACE_QUESTION_SUCCESS,
  GET_REPLACE_QUESTION_FAIL,
  PUBLISHED_TEST,
  PUBLISHED_TEST_SUCCESS,
  PUBLISHED_TEST_FAIL,
  GET_TETS_DETAILS_FOR_EDIT_SUCCESS,
  GET_TETS_DETAILS_FOR_EDIT_FAIL,
  GET_TETS_DETAILS_FOR_EDIT,
  UPDATE_BASIC_SETTINGS_FAIL,
  UPDATE_BASIC_SETTINGS,
  EDIT_CREATE_TEST_SECTION,
  EDIT_CREATE_TEST_SECTION_FAIL,
  GET_QUESTIONBANK_LIST,
  GET_SECTION_RULE_LIST_SUCCESS,
  GET_SECTION_RULE_LIST_FAIL,
  DELETE_SECTION_RULE_LIST_SUCCESS,
  DELETE_SECTION_RULE_LIST_FAIL,
  GET_BANK_LIST_WITH_PERMISSION_ROUTE,
  GET_USER_ROLES_LIST_SUCCESS,
  GET_USER_ROLES_LIST_FAIL,
  GET_ORGANISATION_DROPDOWNLIST,
  GET_ORGANISATION_LIST_SUCCESS_WITH_PAGINATION,
  GET_ORGANISATION_DROPDOWNLIST_SUCCESS,
  GET_ORGANISATION_DROPDOWNLIST_FAIL,
  GET_VIEW_REPORT_LIST_SUCCESS,
  GET_VIEW_REPORT_LIST_FAIL,
  GET_VIEW_REPORT_LIST,
  GET_REPORT_DETAIL_LIST_SUCCESS,
  GET_REPORT_DETAIL_LIST_FAIL,
  GET_REPORT_DETAIL_LIST,
  GET_REPORT_QUESTION_BANK,
  GET_REPORT_QUESTIONBANK_LIST_FAIL,
  GET_REPORT_QUESTIONBANK_LIST_SUCCESS,
  GET_TASK_QUESTION_BANK_LIST_SUCCESS,
  GET_TASK_QUESTION_BANK_LIST_FAIL,
  GET_TASK_VIEW_DETAIL_LIST,
  GET_VIEWDETAILS_LIST_SUCCESS,
  GET_VIEWDETAILS_LIST_FAIL,
  GET_TASKS_STATUS,
  GET_TASKS_STATUS_SUCCESS,
  GET_TASKS_TYPE_SUCCESS,
  GET_TASKS_TYPE,
  CREATE_ACTIVITY_REQUEST_FAILURE,
  CREATE_ACTIVITY_REQUEST_SUCCESS,
  CREATE_ACTIVITY_REQUEST,
  RECENT_ACTIVITY_REQUEST_FAILURE,
  RECENT_ACTIVITY_REQUEST_SUCCESS,
  RECENT_ACTIVITY_REQUEST,
  FETCH_ACTIVITY_REQUEST_FAILURE,
  FETCH_ACTIVITY_REQUEST_SUCCESS,
  FETCH_ACTIVITY_REQUEST,
  GET_SUBJECT_TAGS,
  GET_SUBJECT_TAGS_SUCCESS,
  GET_SUBJECT_TAGS_FAIL,
  GET_CATEGORY_LIST_PAGINATION,
  GET_CATEGORY_LIST_PAGINATION_SUCCESS,
  GET_CATEGORY_LIST_PAGINATION_FAIL,
  SHOW_LOADER,
  HIDE_LOADER,
} from './constant';
import {
  CREATE_TASKS,
  // CREATE_TESTS,
  CREATE_TESTS_BASIC_SETTING,
  CREATE_TESTS_SECTION,
  VALIDATE_SECTION_RULE,
  GET_SECTION_RULE_LIST,
  // GET_VIEW_REPORT_LIST,
  CREATE_USERS,
  EDIT_REVIEW_STATUS,
  GET_CATEGORY,
  GET_IDENTIFIER,
  GET_LOD,
  GET_ORGANISATION,
  GET_PRODUCT,
  GET_PRODUCT_TYPE_LIST,
  GET_QUESTIONBANK,
  GET_REPLACE_THIS_QUESTION,
  GET_REPORT_DATA,
  GET_REVIEW_DATA,
  GET_ROLES,
  GET_SUBJECT_TAG,
  GET_TASKS,
  GET_TASKS_OF_USER,
  GET_TEST_LISTS,
  GET_USERS,
  PATCH_SELECT_QUESTION,
  GET_BANK_LIST_WITH_PERMISSION,
  GET_USERS_ROLES_LIST,
  DELETE_SECTION_RULE_LIST,
  GET_USER_ORGANIZATIONDROPDOWNLIST,
  GET_REPORT_LIST,
  GET_REPORTDETAIL_LIST,
  GET_REPORTQUESTIONBANK_LIST,
  GET_TASK_QUESTION_BANK_LIST,
  CREATE_NEW_TASK,
  GET_TASKS_STATUS_API,
  GET_TASKS_TYPE_API,
  CREATE_ACTIVITY,
  GET_RECENT_ACTIVITIES,
  VIEW_ACTIVITY,
} from '../action/apiPath';
import axios from 'axios';
const userInfo = localStorage?.getItem('userInfo');
const jwt = userInfo ? JSON.parse(userInfo).jwt : '';
axios.defaults.headers.common['Authorization'] = `jwt ${jwt}`;
import {
  Change_qdr_status,
  change_test_screen,
  changeEdit_test_screen,
  ChangeOrganisation,
  // changeOrganisation,
  Get_Review,
  Get_Rule_List,
  Get_Task_Management,
  Get_Test_Detail_For_Edit,
  Get_Test_list,
  GetUserLists,
} from './action';
import { TakeableChannel } from 'redux-saga';

interface ApiResponse {
  status: number;
  data: any;
}
// ______________ START : function of CreateQuestionSaga with data to put in reducer ______________
function* selectQuestionBank({ data, id }: { data: any; id: any }): Generator<any, void, ApiResponse> {
  const organizationId = localStorage.getItem('selectedOrgId');
  if (id) {
    if (data !== null) {
      try {
        const url = `${PATCH_SELECT_QUESTION}${id}/select-question-bank/${organizationId}/`;
        const body = {
          question_bank_id: data,
        };

        const response = yield call(axios.patch, url, body);
        if (response.status === 200) {
          yield put({ type: BASIC_INFO, response, screen: 1 });
        } else {
          yield put({ type: BASIC_INFO, response, screen: 0 });
        }
      } catch (err) {
        let keys: string[] = [];
        if (axios.isAxiosError(err) && err?.response?.data) {
          keys = Object.keys(err.response.data);
        }
        if (keys.length > 0) {
          if (keys.length > 0) {
            const firstErrorKey = keys[0];
            if (err instanceof Error && axios.isAxiosError(err) && err?.response?.data) {
              id
                ? alert(`${keys[0].toUpperCase()} : ${err?.response?.data[firstErrorKey]}`)
                : alert('Select any of the question Bank');
            }
          }
        }
      }
    } else {
      alert('Select any of the question Bank');
    }
  }
}

function* basicInfoSelect({
  data,
  id,
  format,
}: {
  data: any;
  id: any;
  format: any;
}): Generator<any, void, ApiResponse> {
  const organizationId = localStorage.getItem('selectedOrgId');
  const url = `${PATCH_SELECT_QUESTION}${id}/select-basic-info/${organizationId}/`;
  const body = data;
  if (data.format === 1) {
    body.question_group = data.question_group.map((item: any) => ({
      idx: item?.idx,
      question_type_id: item?.question_type_id,
      difficulty: item?.difficulty,
      category: item?.category,
      academic_year: item?.academic_year,
      primary_tag_id: item?.primary_tag?.id,
      secondary_tags: item?.secondary_tags?.map((tag: any) => tag?.id),
      free_tags: item?.free_tags?.map((tag: any) => tag.id),
      new_free_tags: [],
      primary_tag: item?.primary_tag,
      secondary_tag: item?.secondary_tags,
      free_tag: item?.free_tags ?? [],
      new_free_tag: [],
      task_label: item?.task_label ?? item?.edit_task_label ?? null,
      edit_task_label: item?.edit_task_label ?? null,
    }));
  }

  try {
    const response = yield call(axios.patch, url, body);
    if (response.status === 200) {
      if (format === 1) {
        yield put({ type: QUESTION_CREATION_TWO, response, screen: 2.2 });
      } else {
        yield put({ type: QUESTION_CREATION_ONE, response, screen: 2.1 });
      }
    } else {
      yield put({ type: QUESTION_CREATION_ONE, response, screen: 1 });
    }
  } catch (err) {
    //** */ alert("Input values may be wrong, Please check and try again");
    let keys: string[] = [];
    if (axios.isAxiosError(err) && err?.response?.data) {
      keys = Object.keys(err.response.data);
    }
    if (keys.length > 0) {
      const firstErrorKey = keys[0];
      const secondErrorKey = keys[1];
      if (err instanceof Error && axios.isAxiosError(err) && err?.response?.data) {
        alert(
          `${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]} 
${keys[1] ? keys[1]?.toUpperCase() + ' : ' + err?.response?.data[secondErrorKey] : ''}`
        );
      }
    }
  }
}

function* questionTypeSelection({ data }: { data: any }) {
  yield put({ type: QUESTION_CREATION_TWO, data, screen: 2.2 });
}

function* questionTypeback() {
  yield put({ type: QUESTION_CREATION_ONE, screen: 2.1 });
}

function* questionTypecancel() {
  yield put({ type: QUESTION_CREATION_CANCEL, screen: 0 });
}

function* questionTypechooseOnlyBack({ data }: { data: any }) {
  yield put({ type: QUESTION_CREATION_CHOOSE_BACK, screen: data });
}

function* question_creation_apicall({
  data,
  id,
}: {
  data: any;
  id: string | number;
}): Generator<any, void, ApiResponse> {
  const organizationId = localStorage.getItem('selectedOrgId');
  const url = `${PATCH_SELECT_QUESTION}${id}/create-question/${organizationId}/`;
  const body = data;

  try {
    const response = yield call(axios.patch, url, body);
    if (response.status === 200) {
      yield put({ type: SEND_FOR_REVIEW, response, screen: 3 });
    } else {
      yield put({ type: QUESTION_CREATION_TWO, response, screen: 2.2 });
    }
  } catch (err) {
    let keys: string[] = [];
    if (axios.isAxiosError(err) && err?.response?.data) {
      keys = Object.keys(err.response.data);
    }
    if (keys.length > 0) {
      const firstErrorKey = keys[0];
      const secondErrorKey = keys[1];
      if (err instanceof Error && axios.isAxiosError(err) && err?.response?.data) {
        alert(`${keys[0]?.toUpperCase()} : ${err?.response?.data[firstErrorKey]}
${keys[1] ? keys[1]?.toUpperCase() + ' : ' + err?.response?.data[secondErrorKey] : ''}`);
      }
    }
  }
}
// ______________ END : function of CreateQuestionSaga with data to put in reducer ______________

function* get_report_IRT_apicall(): Generator<any, void, ApiResponse> {
  const url = `${GET_REPORT_DATA}?report_type=irt`;

  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_IRT_REPONSE_SUCCESS, response });
    } else {
      yield put({ type: GET_IRT_REPONSE_FAIL, response });
    }
  } catch (err) {
    let keys: string[] = [];
    if (axios.isAxiosError(err) && err?.response?.data) {
      keys = Object.keys(err.response.data);
    }
    if (keys.length > 0) {
      const firstErrorKey = keys[0];
      if (err instanceof Error && axios.isAxiosError(err) && err?.response?.data) {
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* get_report_QDR_apicall(action: any): Generator<any, void, ApiResponse> {
  const url = `${GET_REPORT_DATA}?report_type=qdr&subject_tags_ids=${action.subjectId}`;

  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_QDR_REPONSE_SUCCESS, response });
      yield put(Change_qdr_status(false));
    } else {
      yield put({ type: GET_QDR_REPONSE_FAIL, response });
    }
  } catch (err) {
    let keys: string[] = [];
    if (axios.isAxiosError(err) && err?.response?.data) {
      keys = Object.keys(err.response.data);
    }
    if (keys.length > 0) {
      const firstErrorKey = keys[0];
      if (err instanceof Error && axios.isAxiosError(err) && err?.response?.data) {
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* get_task_apicall(action: any): Generator<any, void, ApiResponse> {
  const url = `${GET_TASKS}${action.orgId}/?limit=${action.limit}&page=${action.page}&assign_to_me=${action?.taskFilterValue}&task_status=${action.taskStatus}&task_type=${action.taskTypeFilterValue}&sort=${action.sort}`;

  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_TASKS_SUCCESS, response });
    } else {
      yield put({ type: GET_TASKS_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      yield put({ type: GET_TASKS_FAIL, response: err?.response?.data });
      const error = err?.response?.data?.error;
      action?.toast?.remove('all');
      action?.toast?.add(error, 'error');
    }
  }
}

function* get_task_status_apicall(action: any): Generator<any, void, ApiResponse> {
  const url = `${GET_TASKS_STATUS_API}`;
  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_TASKS_STATUS_SUCCESS, response });
    } else {
      yield put({ type: GET_TASKS_FAIL, response });
    }
  } catch (err) {
    let keys: string[] = [];
    if (axios.isAxiosError(err) && err?.response?.data) {
      keys = Object.keys(err.response.data);
    }
    if (keys.length > 0) {
      const firstErrorKey = keys[0];
      if (err instanceof Error && axios.isAxiosError(err) && err?.response?.data) {
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}
function* get_task_type_apicall(action: any): Generator<any, void, ApiResponse> {
  const url = `${GET_TASKS_TYPE_API}`;
  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_TASKS_TYPE_SUCCESS, response });
    } else {
      yield put({ type: GET_TASKS_FAIL, response });
    }
  } catch (err) {
    let keys: string[] = [];
    if (axios.isAxiosError(err) && err?.response?.data) {
      keys = Object.keys(err.response.data);
    }
    if (keys.length > 0) {
      const firstErrorKey = keys[0];
      if (err instanceof Error && axios.isAxiosError(err) && err?.response?.data) {
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}
function* get_task_detail_apicall({ id }: { id: any }): Generator<any, void, ApiResponse> {
  const url = `${GET_TASKS}${id}/get_task_details/`;
  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_TASKS_DETAIL_SUCCESS, response });
    } else {
      yield put({ type: GET_TASKS_DETAIL_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* delete_task_apicall({ id }: { id: string | number }): Generator<any, void, ApiResponse> {
  const url = `${GET_TASKS}${id}/delete_task/`;
  try {
    const response = yield call(axios.delete, url);
    if (response.status === 200) {
      yield put({ type: DELETE_TASKS_SUCCESS, response });
      yield put(Get_Task_Management('', ''));
    } else {
      yield put({ type: DELETE_TASKS_FAIL, response });
      yield put(Get_Task_Management('', ''));
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* approve_task_apicall({ id }: { id: string | number }): Generator<any, void, ApiResponse> {
  const url = `${GET_TASKS}${id}/approve/`;
  const body = {};

  try {
    const response = yield call(axios.patch, url, body);
    if (response.status === 200) {
      yield put({ type: APPROVE_TASKS_SUCCESS, response });
      yield put(Get_Task_Management('', ''));
    } else {
      yield put({ type: APPROVE_TASKS_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* editTask_apicall({ id, body }: { id: string | number; body: any }): Generator<any, void, ApiResponse> {
  const url = `${GET_TASKS}${id}/edit_task/`;
  try {
    const response = yield call(axios.patch, url, body);
    if (response.status === 200) {
      yield put({ type: EDIT_TASK_SUCCESS, response });
      yield put(Get_Task_Management('', ''));
    } else {
      yield put({ type: EDIT_TASK_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* getTaskofUser_apicall(action: any): Generator<any, void, ApiResponse> {
  const url = `${GET_TASKS_OF_USER}?task_type=${action.task_type !== undefined ? action.task_type : ''}`;

  try {
    const response = yield call(axios.get, url);
    // eslint-disable-next-line no-console
    console.log('response', response);
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* get_review_alldata_apicall(action: {
  author: any[];
  subject: any[];
  free_tags: any[];
  sort: any;
}): Generator<any, void, ApiResponse> {
  const author = action.author?.map((user) => user.id).join(',');
  const subject = action.subject?.map((user) => user.id).join(',');
  const free = action.free_tags?.map((user) => user.id).join(',');
  const sort = action.sort;

  const url = `${GET_REVIEW_DATA}?subject_tags=${
    subject ?? ''
  }&question_authors=${author ?? ''}&free_tags=${free ?? ''}&sort=${sort !== null ? sort : ''}`;

  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: REVIEW_ALLDATA_SUCCESS, response });
    } else {
      yield put({ type: REVIEW_ALLDATA_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* get_review_needdata_apicall(action: any): Generator<any, void, ApiResponse> {
  const author = action.author.map((user: any) => user.id).join(',');
  const subject = action.subject.map((user: any) => user.id).join(',');
  const free = action.free_tags.map((user: any) => user.id).join(',');
  const sort = action.sort;

  const url = `${GET_REVIEW_DATA}?in_review=True&subject_tags=${
    subject ?? ''
  }&question_authors=${author ?? ''}&free_tags=${free ?? ''}&sort=${sort !== null ? sort : ''}`;

  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: NEED_REVIEW_ALLDATA_SUCCESS, response });
    } else {
      yield put({ type: NEED_REVIEW_ALLDATA_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* change_review_status_apicall(action: {
  event: { target: { value: any } };
  id: any;
}): Generator<any, void, ApiResponse> {
  const newValue = action.event.target.value;
  const url = `${EDIT_REVIEW_STATUS}${action.id}/update-question-status`;

  const body = { status: newValue };

  try {
    const response = yield call(axios.patch, url, body);
    if (response.status === 200) {
      yield put({ type: CHANGE_REVIEW_STATUS_SUCCESS, response });
      yield put(Get_Review(null, null, null, []));
    } else {
      yield put({ type: CHANGE_REVIEW_STATUS_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* get_userList_apicall(action: {
  organizationId: any;
  keyword: any;
  sort: any;
  limit: any;
  page: any;
}): Generator<any, void, ApiResponse> {
  try {
    const organizationId = action.organizationId;
    const keyword = action.keyword;
    const sort = action.sort;
    const limit = action.limit;
    const page = action.page;
    const url = `${GET_USERS}${organizationId}/?keyword=${keyword !== null ? keyword : ''}&sort=${sort !== null ? sort : ''}&page=${page !== null ? page : ''}&limit=${limit !== null ? limit : ''}`;

    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_USER_LIST_SUCESS, response });
    } else {
      yield put({ type: GET_USER_LIST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err.response;
      yield put({ type: GET_USER_LIST_FAIL, response });
    }
  }
}
function* get_userDetail_apicall(action: { id: any }): Generator<any, void, ApiResponse> {
  const url = `${GET_USERS}${action.id}/user-details/`;
  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_USER_DETAIL_SUCCESS, response });
    } else {
      yield put({ type: GET_USER_DETAIL_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* get_userRoleList_apicall(): Generator<any, void, ApiResponse> {
  const url = `${GET_USERS_ROLES_LIST}`;
  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_USER_ROLES_LIST_SUCCESS, response });
    } else {
      yield put({ type: GET_USER_ROLES_LIST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* get_userRole_apicall(): Generator<any, void, ApiResponse> {
  const url = `${GET_ROLES}`;
  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_USER_ROLES_SUCCESS, response });
    } else {
      yield put({ type: GET_USER_ROLES_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* get_AddUser_apicall(action: { body: unknown }): Generator<any, void, ApiResponse> {
  const url = `${CREATE_USERS}`;
  try {
    const response = yield call(axios.post, url, action.body);
    if (response.status === 200) {
      yield put({ type: GET_ADD_USER_SUCCESS, response });
      yield put(GetUserLists(null, null, null));
    } else {
      yield put({ type: GET_ADD_USER_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* editUserDetail_apicall(action: { id: any; body: unknown }): Generator<any, void, ApiResponse> {
  const url = `${GET_USERS}${action.id}/update-user/`;
  try {
    const response = yield call(axios.patch, url, action.body);

    if (response.status === 200) {
      yield put({ type: EDIT_USER_DETAIL_SUCCESS, response });
    } else {
      yield put({ type: EDIT_USER_DETAIL_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* getOraganisationList_apicall(action: {
  keyword?: any;
  sort?: any;
  limit?: any;
  page?: any;
  filter?: any;
}): Generator<any, void, ApiResponse> {
  try {
    const keyword = action?.keyword;
    const sort = action?.sort;
    const limit = action?.limit;
    const page = action?.page;
    const url = `${GET_ORGANISATION}?keyword=${keyword ?? ''}&sort=${sort ?? ''}&page=${page ?? ''}&limit=${limit ?? ''}&filter=${action.filter ?? ''}`;
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      if (response.data.count) {
        yield put({ type: GET_ORGANISATION_LIST_SUCCESS_WITH_PAGINATION, response });
      } else {
        yield put({ type: GET_ORGANISATION_LIST_SUCCESS, response });
      }
    } else {
      yield put({ type: GET_ORGANISATION_LIST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err.response;
      yield put({ type: GET_ORGANISATION_LIST_FAIL, response });
    }
  }
}

function* getOraganisationDropdownList_apicall(action: { role_id?: any }): Generator<any, void, ApiResponse> {
  try {
    const url = `${GET_USER_ORGANIZATIONDROPDOWNLIST}?role_id=${action?.role_id}`;
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      if (response.status === 200) {
        yield put({ type: GET_ORGANISATION_DROPDOWNLIST_SUCCESS, response });
      } else {
        yield put({ type: GET_ORGANISATION_DROPDOWNLIST_FAIL, response });
      }
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err.response;
      yield put({ type: GET_ORGANISATION_DROPDOWNLIST_FAIL, response });
    }
  }
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
function* getOraganisationDetail_apicall(action: any) {
  yield put(ChangeOrganisation(1));
}

function* get_userQuestionBank_apicall(action: { organizationId?: any }): Generator<any, void, ApiResponse> {
  const url = `${GET_QUESTIONBANK}${action.organizationId}/`;
  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_USER_QUESTION_BANK_SUCCESS, response });
    } else {
      yield put({ type: GET_USER_QUESTION_BANK_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* getCategoryListList_apicall(action: {
  organizationId?: any;
  key?: any;
  sort?: any;
  limit?: any;
  currentPage?: any;
}): Generator<any, void, ApiResponse> {
  const url = `${GET_CATEGORY}${action.organizationId}/`;
  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_CATEGORY_LIST_SUCCESS, response });
    } else {
      yield put({ type: GET_CATEGORY_LIST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err.response;
      yield put({ type: GET_CATEGORY_LIST_FAIL, response });
    }
  }
}

function* getCategoryListPaginationApicall(action: {
  organizationId?: any;
  key?: any;
  sort?: any;
  limit?: any;
  currentPage?: any;
}): Generator<any, void, ApiResponse> {
  let url = GET_CATEGORY + action.organizationId + '/?';
  const params = new URLSearchParams();
  params.append('keyword', action.key);
  params.append('sort', action.sort);
  if (action.currentPage) {
    params.append('page', action.currentPage);
  }
  if (action.limit) {
    params.append('limit', action.limit);
  }

  url += params.toString();
  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_CATEGORY_LIST_PAGINATION_SUCCESS, response });
    } else {
      yield put({ type: GET_CATEGORY_LIST_PAGINATION_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err.response;
      yield put({ type: GET_CATEGORY_LIST_PAGINATION_FAIL, response });
    }
  }
}

function* getQuestionBankListWithPermisson_apicall(action: {
  org_id: any;
  key?: any;
  sort?: any;
  limit?: any;
  currentPage?: any;
  userId?: any;
}): Generator<any, void, ApiResponse> {
  let url = GET_BANK_LIST_WITH_PERMISSION + action.org_id + '/?';
  const params = new URLSearchParams();
  params.append('keyword', action.key);
  params.append('sort', action.sort);
  if (action.currentPage) {
    params.append('page', action.currentPage);
  }
  if (action.limit) {
    params.append('limit', action.limit);
  }
  if (action.userId) {
    params.append('user_id', action.userId);
  }

  url += params.toString();

  try {
    const response = yield call(axios.get, url);
    const data = response.data;
    yield put({ type: GET_BANK_LIST_WITH_PERMISSION_ROUTE, data });
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err.response;
      yield put({ type: GET_BANK_LIST_WITH_PERMISSION_ROUTE, response });
    }
  }
}

function* getIdentifierListList_apicall(action: {
  organizationId: any;
  key: any;
  sort: any;
  limit?: any;
  currentPage?: any;
}): Generator<any, void, ApiResponse> {
  let url = GET_IDENTIFIER + action.organizationId + '/?';
  const params = new URLSearchParams();
  params.append('name', action.key);
  params.append('sort', action.sort);
  if (action.currentPage) {
    params.append('page', action.currentPage);
  }
  if (action.limit) {
    params.append('limit', action.limit);
  }

  url += params.toString();
  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_IDENTIFIER_LIST_SUCCESS, response });
    } else {
      yield put({ type: GET_IDENTIFIER_LIST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err.response;
      yield put({ type: GET_IDENTIFIER_LIST_FAIL, response });
    }
  }
}

function* getLodListList_apicall(action: {
  organizationId: any;
  key: any;
  sort: any;
  limit?: any;
  currentPage?: any;
}): Generator<any, void, ApiResponse> {
  let url = GET_LOD + action.organizationId + '/?';
  const params = new URLSearchParams();
  params.append('keyword', action.key);
  params.append('sort', action.sort);
  if (action.currentPage) {
    params.append('page', action.currentPage);
  }
  if (action.limit) {
    params.append('limit', action.limit);
  }
  url += params.toString();

  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_LOD_LIST_SUCCESS, response });
    } else {
      yield put({ type: GET_LOD_LIST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err.response;
      yield put({ type: GET_LOD_LIST_FAIL, response });
    }
  }
}

function* getSubjectPipelineListList_apicall(action: {
  organizationId: any;
  key: any;
  sort: any;
  limit: any;
  page: any;
}): Generator<any, void, ApiResponse> {
  let url = GET_SUBJECT_TAG + action.organizationId + '/?';
  const params = new URLSearchParams();
  params.append('keyword', action.key);
  params.append('sort', action.sort);
  if (action.limit) {
    params.append('limit', action.limit);
  }
  if (action.page) {
    params.append('page', action.page);
  }

  url += params.toString();
  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_SUBJECT_PIPELINE_LIST_SUCCESS, response });
    } else {
      yield put({ type: GET_SUBJECT_PIPELINE_LIST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err.response;
      yield put({ type: GET_SUBJECT_PIPELINE_LIST_FAIL, response });
    }
  }
}

function* getQuestionBankListList_apicall(action: {
  organizationId: any;
  key: any;
  sort: any;
  limit?: any;
  currentPage?: any;
}): Generator<any, void, ApiResponse> {
  let url = GET_QUESTIONBANK + action.organizationId + '/?';
  const params = new URLSearchParams();

  params.append('keyword', action.key);
  params.append('sort', action.sort);
  if (action.limit) {
    params.append('limit', action.limit);
  }
  if (action.currentPage) {
    params.append('page', action.currentPage);
  }

  url += params.toString();

  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_QUESTION_BANK_LIST_SUCCESS, response });
    } else {
      yield put({ type: GET_QUESTION_BANK_LIST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err.response;
      yield put({ type: GET_QUESTION_BANK_LIST_FAIL, response });
    }
  }
}

/** CREATE NEW TASK */
function* createTask_apicall(action: { body: unknown }): Generator<any, void, ApiResponse> {
  const url = `${CREATE_TASKS}`;
  try {
    const response = yield call(axios.post, url, action.body);
    if (response.status === 200) {
      yield put({ type: CREATE_TASK_SUCCESS, response });
    } else {
      yield put({ type: CREATE_TASK_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

/** PRODUCT TYPE IN MASTERS */
function* getProductType_apicall(): Generator<any, void, ApiResponse> {
  const url = `${GET_PRODUCT_TYPE_LIST}`;
  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_PRODUCT_TYPE_SUCCESS, response });
    } else {
      yield put({ type: GET_PRODUCT_TYPE_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

//___________________________ Test Creation API _________________
function* getNewTest_basic_setting_apicall(action: {
  body: any;
  toast: any;
  refreshTestDetails?: any;
}): Generator<any, void, ApiResponse> {
  const url = `${CREATE_TESTS_BASIC_SETTING}`;
  const screen = 1;
  try {
    yield put({ type: SHOW_LOADER });
    const body: any = { ...action?.body };
    body.free_tags = body?.free_tags?.map((item: any) => item.id);
    const response = yield call(axios.post, url, body);
    if (response.status === 201) {
      yield put({ type: CREATE_TEST_BASIC_SETTING_SUCCESS, response, screen, body: action?.body });
      yield put(Get_Test_Detail_For_Edit(response?.data?.data?.id));
      action?.refreshTestDetails();
      action?.toast?.add(response.data.message, 'success');
    } else {
      yield put({ type: CHANGE_ADD_TEST_SCREEN, screen });
      action?.refreshTestDetails();
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      action?.toast?.add(err.response.data.error, 'error');
    }
  } finally {
    yield put({ type: HIDE_LOADER });
  }
}

function* getNewTest_Section_apicall(action: {
  body: unknown;
  testCreationId: any;
  testType: any;
  organizationId: any;
  toast: any;
}): Generator<any, void, ApiResponse> {
  const screen = 2;
  const body = action.body;
  let url = '';
  if (action.testType === 0) {
    url = `${CREATE_TESTS_SECTION}${action.testCreationId}/add_groups/`;
  } else if (action.testType === 1) {
    url = `${CREATE_TESTS_SECTION}${action.testCreationId}/add_sections/`;
  } else {
    url = `${CREATE_TESTS_SECTION}${action.testCreationId}/add_groups_loft/${action.organizationId}/`;
  }
  try {
    yield put({ type: SHOW_LOADER });
    const response = yield call(axios.patch, url, action.body);
    if (response.status === 200) {
      yield put({ type: CREATE_TEST_SECTION_SUCCESS, screen, body });
      if (action.testCreationId) {
        yield put(Get_Test_Detail_For_Edit(action.testCreationId));
      }
      action?.toast?.add(response.data.message, 'success');
    } else {
      yield put({ type: CREATE_TEST_SECTION_FAIL, screen, body });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      action?.toast?.add(err.response.data.error, 'error');
    }
  } finally {
    yield put({ type: HIDE_LOADER });
  }
}

function* validate_Section_Rule_apicall(action: {
  body: unknown;
  testCreationId: any;
  organizationId: any;
  toast: any;
  setModal?: any;
}): Generator<any, void, ApiResponse> {
  let url = '';
  url = `${VALIDATE_SECTION_RULE}${action.testCreationId}/loft-section-validations/${action.organizationId}/`;
  try {
    const response = yield call(axios.post, url, action.body);
    if (response.status === 200) {
      yield put({ type: VALIDATE_SECTION_RULE_SUCCESS, response });
      action?.setModal(true);
    } else {
      yield put({ type: VALIDATE_SECTION_RULE_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      action?.toast?.add(err.response.data.error, 'error');
    }
  }
}

function* getSection_RuleList_apicall(action: {
  organizationId: any;
  testCreationId: any;
  group_id: any;
  section_id: any;
}): Generator<any, void, ApiResponse> {
  const url = `${GET_SECTION_RULE_LIST}${action.organizationId}/?test_id=${action.testCreationId}&group_id=${action.group_id}&section_id=${action.section_id}`;

  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_SECTION_RULE_LIST_SUCCESS, response });
    } else {
      yield put({ type: GET_SECTION_RULE_LIST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      let response = err.response;
      if (response.data.error == 'No search result found') {
        response = {
          data: [],
          status: 200,
          statusText: 'OK',
          headers: {},
          config: {
            headers: new axios.AxiosHeaders(),
          },
        };
        yield put({ type: GET_SECTION_RULE_LIST_SUCCESS, response });
      } else {
        yield put({ type: GET_SECTION_RULE_LIST_FAIL, response });
      }
    }
  }
}

function* getTask_QuestionBank_List_apicall(action: { organizationId: any }): Generator<any, void, ApiResponse> {
  const url = `${GET_TASK_QUESTION_BANK_LIST}${action.organizationId}/`;

  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_TASK_QUESTION_BANK_LIST_SUCCESS, response });
    } else {
      yield put({ type: GET_TASK_QUESTION_BANK_LIST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err.response;
      yield put({ type: GET_TASK_QUESTION_BANK_LIST_FAIL, response });
    }
  }
}

function* getTask_ViewDetails_List_apicall(action: {
  taskId: any;
  organizationId: any;
  limit: any;
  currentPage: any;
  toast: any;
}): Generator<any, void, ApiResponse> {
  const url = `${CREATE_NEW_TASK}${action.taskId}/get-task-details/${action.organizationId}/?limit=${action.limit}&page=${action.currentPage}
`;

  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_VIEWDETAILS_LIST_SUCCESS, response });
    } else {
      yield put({ type: GET_VIEWDETAILS_LIST_FAIL, response });
      action?.toast?.add(response?.data.error, 'error');
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      action?.toast?.add(err?.response?.data?.error, 'error');
      yield put({ type: GET_VIEWDETAILS_LIST_FAIL, response: err.response });
    }
  }
}
function* get_View_Report_List_apicall(action: {
  organizationId: any;
  keyword: any;
  sort: any;
  limit: any;
  currentPage: any;
}): Generator<any, void, ApiResponse> {
  const url = GET_REPORT_LIST(action.organizationId, action.keyword, action.sort, action.limit, action.currentPage);

  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_VIEW_REPORT_LIST_SUCCESS, response });
    } else {
      yield put({ type: GET_VIEW_REPORT_LIST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err.response;
      yield put({ type: GET_VIEW_REPORT_LIST_FAIL, response });
    }
  }
}

function* createActivitySaga_apicall(action: {
  taskId: any;
  userId: any;
  task_activity_status: any;
  created_at: any;
  toast?: any;
  refreshActivity?: any;
}): Generator<any, void, ApiResponse> {
  const url = CREATE_ACTIVITY;

  const payload = {
    task_id: action.taskId,
    user_id: action.userId,
    task_activity_status: action.task_activity_status,
    created_at: action.created_at,
  };

  try {
    const response = yield call(axios.post, url, payload);

    if (response?.data.status === 200) {
      yield put({ type: CREATE_ACTIVITY_REQUEST_SUCCESS, response });
      action?.refreshActivity();
    } else {
      yield put({ type: CREATE_ACTIVITY_REQUEST_FAILURE, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err.response;
      yield put({ type: CREATE_ACTIVITY_REQUEST_FAILURE, response });
      action?.toast?.add(response.data.error, 'error');
    }
  }
}

function* recentActivitySaga_apicall(action: { orgId: any }): Generator<any, void, ApiResponse> {
  const url = GET_RECENT_ACTIVITIES(action.orgId); // Correctly generate the API URL
  try {
    const response = yield call(axios.get, url); // No need for `params` since `orgId` is already in the URL
    if (response?.data.status === 200) {
      yield put({ type: RECENT_ACTIVITY_REQUEST_SUCCESS, response });
    } else {
      yield put({ type: RECENT_ACTIVITY_REQUEST_FAILURE, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err?.response;
      yield put({ type: RECENT_ACTIVITY_REQUEST_FAILURE, response });
    }
  }
}

function* fetchActivitySaga_apicall(action: {
  orgId: string;
  taskId: string;
  limit: number;
  currentPage: number;
}): Generator<any, void, ApiResponse> {
  const { orgId, taskId, limit, currentPage } = action;
  const url = VIEW_ACTIVITY(orgId, taskId, limit, currentPage);
  try {
    const response: ApiResponse = yield call(axios.get, url);
    if (response?.status === 200) {
      yield put({ type: FETCH_ACTIVITY_REQUEST_SUCCESS, response });
    } else {
      yield put({ type: FETCH_ACTIVITY_REQUEST_FAILURE, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err.response) {
      const response = err.response;
      yield put({ type: FETCH_ACTIVITY_REQUEST_FAILURE, response });
    } else {
      yield put({ type: FETCH_ACTIVITY_REQUEST_FAILURE, payload: { message: 'An unknown error occurred' } });
    }
  }
}

function* get_reportQuestionBank_apicall(action: { organizationId: any }): Generator<any, void, ApiResponse> {
  const url = GET_REPORTQUESTIONBANK_LIST(action.organizationId);

  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_REPORT_QUESTIONBANK_LIST_SUCCESS, response });
    } else {
      yield put({ type: GET_REPORT_QUESTIONBANK_LIST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err.response;
      yield put({ type: GET_REPORT_QUESTIONBANK_LIST_FAIL, response });
    }
  }
}

function* get_ReportDetailList_apicall(action: { organizationId: any; id: any }): Generator<any, void, ApiResponse> {
  const url = GET_REPORTDETAIL_LIST(action.organizationId, action.id);
  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_REPORT_DETAIL_LIST_SUCCESS, response });
    } else {
      yield put({ type: GET_REPORT_DETAIL_LIST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const response = err.response;
      yield put({ type: GET_REPORT_DETAIL_LIST_FAIL, response });
    }
  }
}

function* delete_Section_RuleList_apicall(action: {
  organizationId: any;
  testCreationId: any;
  group_id: any;
  section_id: any;
  toast: any;
  deleteFormat: any;
  rules: any;
  subRules: any;
}): Generator<any, void, ApiResponse> {
  const format = action.deleteFormat;
  const url = `${DELETE_SECTION_RULE_LIST}${action.organizationId}/?test_id=${action.testCreationId}&group_id=${action.group_id}&section_id=${action.section_id}&rule_ids=${action.rules}&sub_rule_ids=${action.subRules}`;

  try {
    const response = yield call(axios.delete, url);
    if (response.status === 200) {
      yield put({ type: DELETE_SECTION_RULE_LIST_SUCCESS, format });
      yield put(Get_Rule_List(action.organizationId, action.testCreationId, action.group_id, action.section_id));
      action?.toast?.add(response.data.message, 'success');
    } else {
      yield put({ type: DELETE_SECTION_RULE_LIST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      action?.toast?.add(err.response.data.error, 'error');
    }
  }
}

function* getNewTestPublish(action: any): Generator<any, void, any> {
  const screen = 0;
  const url = `${GET_TEST_LISTS}${action.testCreationId}/advanced_settings/`;
  try {
    const response = yield call(axios.patch, url, action.body);
    if (response.status === 200) {
      yield put({ type: PUBLISH_TEST_SUCCESS, screen });
      yield put({ type: CHANGE_TEST_SCREEN, screen });
    } else {
      yield put({ type: PUBLISH_TEST_FAIL, screen });
    }
    action?.handleSubmit(response);
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* getTestCreationLists_apicall(action: {
  sort: any;
  filterParams: any;
  limit: any;
  key: any;
  currentPage: any;
}): Generator<any, void, ApiResponse> {
  const { sort, filterParams, limit, key, currentPage } = action;
  // Start with the base URL
  let url = `${GET_TEST_LISTS}?keyword=${key ?? ''}&sort=${sort}`;
  if (limit) {
    url += `&limit=${limit}`;
  }
  if (currentPage) {
    url += `&page=${currentPage}`;
  }

  // Check if filterParams is not empty
  if (Object.keys(filterParams).length > 0) {
    url += `&player_types=${filterParams.player_tags}&free_tags=${filterParams.free_tags}&ids=${filterParams.ids}&authors=${filterParams.author_tags}&year=${filterParams.year}&status=${filterParams.status}`;
  }

  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_TEST_LISTING_SUCCESS, response });
    } else {
      yield put({ type: GET_TEST_LISTING_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* delete_test_apicall({ id }: { id: string | number }): Generator<any, void, ApiResponse> {
  const url = `${GET_TEST_LISTS}${id}/test_delete/`;

  try {
    const response = yield call(axios.delete, url);
    if (response.status === 204) {
      yield put({ type: DELETE_TEST_SUCCESS, response });
      yield put(Get_Test_list('', ''));
    } else {
      yield put({ type: DELETE_TEST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

//___________________________________________ unpublish test ____________________//
function* unpublish_test_apicall({
  id,
  toast,
}: {
  id: string | number;
  toast: any;
}): Generator<any, void, ApiResponse> {
  const url = `${GET_TEST_LISTS}publish_unpublish/`;
  const UnProcessingToastId = toast?.add('Unpublishing is inprogress...', 'processing');

  const body = {
    id: id,
    publish: false,
  };

  try {
    const response = yield call(axios.post, url, body);
    if (response.status === 200) {
      toast?.remove(UnProcessingToastId);
      yield put({ type: UNPUBLISH_TEST_SUCCESS, response });
      toast?.add(response.data.message, 'success');
    } else {
      yield put({ type: UNPUBLISH_TEST_FAIL, response });
    }
  } catch (err) {
    let keys: string[] = [];
    if (axios.isAxiosError(err) && err?.response?.data) {
      keys = Object.keys(err.response.data);
    }
    if (keys.length > 0) {
      const firstErrorKey = keys[0];
      if (err instanceof Error && axios.isAxiosError(err) && err?.response?.data) {
        alert(`${keys[0]?.toUpperCase()} : ${err?.response?.data[firstErrorKey]}
${keys[1] ? keys[1]?.toUpperCase() + ' : ' + err?.response?.data[keys[1]] : ''}`);
      }
    }
  }
}

function* publish_test_apicall({ id, toast }: { id: string | number; toast: any }): Generator<any, void, ApiResponse> {
  const url = `${GET_TEST_LISTS}publish_unpublish/`;
  const processingToastId = toast?.add('Publishing is inprogress...', 'processing');
  const body = {
    id: id,
    publish: true,
  };

  try {
    const response = yield call(axios.post, url, body);
    if (response.status === 200) {
      toast?.remove(processingToastId);
      yield put({ type: PUBLISHED_TEST_SUCCESS, response });
      toast?.add(response.data.message, 'success');
    } else {
      yield put({ type: PUBLISHED_TEST_FAIL, response });
    }
  } catch (err) {
    let keys: string[] = [];
    if (axios.isAxiosError(err) && err?.response?.data) {
      keys = Object.keys(err.response.data);
    }
    if (keys.length > 0) {
      const firstErrorKey = keys[0];
      if (err instanceof Error && axios.isAxiosError(err) && err?.response?.data) {
        alert(`${keys[0]?.toUpperCase()} : ${err?.response?.data[firstErrorKey]}
${keys[1] ? keys[1]?.toUpperCase() + ' : ' + err?.response?.data[keys[1]] : ''}`);
      }
    }
  }
}

//___________________________________________ duplicate test ____________________//
function* duplicate_test_apicall({
  id,
  name,
}: {
  id: string | number;
  name: string;
}): Generator<any, void, ApiResponse> {
  const url = `${GET_TEST_LISTS}duplicate/`;

  const body = {
    id: id,
    name: name,
  };

  try {
    const response = yield call(axios.post, url, body);
    if (response.status === 201) {
      yield put({ type: DUPLICATE_TEST_SUCCESS, response });
    } else {
      yield put({ type: DUPLICATE_TEST_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

// product type
function* getProductsType_apicall(): Generator<any, void, ApiResponse> {
  const url = `${GET_PRODUCT}`;

  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: PRODUCT_TYPE_SUCCUSS, response });
    } else {
      yield put({ type: PRODUCT_TYPE_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* getSubjectTags_apicall({ orgId }: { orgId: string | number }): Generator<any, void, ApiResponse> {
  const url = `${GET_SUBJECT_TAG}${orgId}/`;

  try {
    const response = yield call(axios.get, url);
    if (response.status === 200) {
      yield put({ type: GET_SUBJECT_TAGS_SUCCESS, response });
    } else {
      yield put({ type: GET_SUBJECT_TAGS_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

// ______ Test Details ___
function* get_TestDetails_apicall({ id }: { id: string | number }): Generator<any, void, ApiResponse> {
  const url = `${GET_TEST_LISTS}${id}/test_details/`;

  try {
    const result = yield call(axios.get, url);
    const response = result.data;
    if (result.status === 200) {
      yield put({ type: GET_TEST_DETAILS_SUCCESS, response });
      yield put(change_test_screen(2));
    } else {
      yield put({ type: GET_TEST_DETAILS_FAIL, response });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

// ______ Test Details paticular id to edit___

function* get_TestDetails_for_edit_apicall({ id }: { id: string | number }): Generator<any, void, ApiResponse> {
  const url = `${GET_TEST_LISTS}${id}/test_details/`;

  try {
    const result = yield call(axios.get, url);
    if (result.status === 200) {
      const response = result.data;
      yield put({ type: GET_TETS_DETAILS_FOR_EDIT_SUCCESS, response, id });
      yield put(change_test_screen(3));
    } else {
      yield put({ type: GET_TETS_DETAILS_FOR_EDIT_FAIL, result, id });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      const keys = Object.keys(err.response.data);
      if (keys.length > 0) {
        const firstErrorKey = keys[0];
        alert(`${keys[0].toUpperCase()} : ${err.response.data[firstErrorKey]}`);
      }
    }
  }
}

function* get_Replace_apicall(action: {
  organizationId: any;
  id: any;
  otherId: any;
  toast: any;
  testId?: any;
}): Generator<any, void, ApiResponse> {
  const body = {
    question_id: action.id,
    ids: action.otherId,
  };
  let url = `${GET_REPLACE_THIS_QUESTION}${action.organizationId}/`;
  if (action?.testId) {
    url = url + `?test_id=${action?.testId}`;
  }

  try {
    const response = yield call(axios.post, url, body);
    if (response.status === 200) {
      yield put({ type: GET_REPLACE_QUESTION_SUCCESS, response });
      action?.toast?.add('Question replaced sucessfully', 'success');
    } else {
      yield put({ type: GET_REPLACE_QUESTION_FAIL, response });
    }
  } catch (err) {
    //** */ alert("Input values may be wrong, Please check and try again");
    if (axios.isAxiosError(err) && err?.response?.data) {
      action?.toast?.add('No matching questions were found.', 'error');
    }
  }
}

//__________________ Edit test basic settings
function* editTest_basic_setting_apicall(action: {
  id: any;
  body: unknown;
  toast: any;
  refreshTestDetails?: any;
}): Generator<any, void, ApiResponse> {
  const url = `${CREATE_TESTS_BASIC_SETTING}${action.id}/update/`;

  const screen = 1;

  try {
    yield put({ type: SHOW_LOADER });
    const body: any = action.body;
    body.free_tags = body?.free_tags?.map((item: any) => item.id);
    const result = yield call(axios.patch, url, body);
    const response = result.data;
    if (result.status === 200) {
      yield put({ type: CREATE_TEST_BASIC_SETTING_SUCCESS, response, screen, body: action?.body });
      yield put(changeEdit_test_screen(1));
      action?.refreshTestDetails();
      action?.toast?.add(result.data.message, 'success');
    } else {
      yield put({ type: UPDATE_BASIC_SETTINGS_FAIL, result, screen });
      action?.refreshTestDetails();
      yield put(changeEdit_test_screen(1));
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      action?.toast?.add(err.response.data.error, 'error');
    }
  } finally {
    yield put({ type: HIDE_LOADER });
  }
}

function* geteditTest_Section_apicall(action: any): Generator<any, void, any> {
  const screen = 2;
  const body = action.body;

  let url = '';
  if (action.testType === 0) {
    url = `${CREATE_TESTS_SECTION}${action.testCreationId}/update_groups/`;
  } else if (action.testType === 2) {
    url = `${CREATE_TESTS_SECTION}${action.testCreationId}/add_groups_loft/${action.organizationId}/`;
  }

  try {
    yield put({ type: SHOW_LOADER });
    const response = yield call(axios.patch, url, action.body);
    if (response.status === 200) {
      if (action.testCreationId) {
        yield put(Get_Test_Detail_For_Edit(action.testCreationId));
      }
      yield put({ type: CREATE_TEST_SECTION_SUCCESS, screen, body });
      yield put(changeEdit_test_screen(1));
      action?.toast?.add(response.data.message, 'success');
    } else {
      yield put({ type: EDIT_CREATE_TEST_SECTION_FAIL, screen, body });
    }
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response?.data) {
      action?.toast?.add(err.response.data.error, 'error');
    }
  } finally {
    yield put({ type: HIDE_LOADER });
  }
}

// _____ All the functiona and action of CreateQuestion : IMS_AUTHORING_SAGA  ________
function* IMS_AUTHORING_SAGA() {
  yield takeEvery(SELECT_QUESTION_BANK as unknown as TakeableChannel<unknown>, selectQuestionBank);
  yield takeEvery(BASIC_INFORMATION as unknown as TakeableChannel<unknown>, basicInfoSelect);
  yield takeEvery(QUESTION_CREATION_SCREEN_CHANGE as unknown as TakeableChannel<unknown>, questionTypeSelection);
  yield takeEvery(QUESTION_CREATION_SCREEN_BACK, questionTypeback);
  yield takeEvery(QUESTION_CREATION_SCREEN_CANCEL, questionTypecancel);
  yield takeEvery(
    QUESTION_CREATION_SCREEN_CHOOSE_ONLY_BACK as unknown as TakeableChannel<unknown>,
    questionTypechooseOnlyBack
  );
  yield takeEvery(QUESTION_CREATION_FINAL_CALL as unknown as TakeableChannel<unknown>, question_creation_apicall);
  yield takeEvery(GET_REPORT_IRT, get_report_IRT_apicall);
  yield takeEvery(GET_REPORT_QDR, get_report_QDR_apicall);
  yield takeEvery(GET_TASKS_LIST, get_task_apicall);
  yield takeEvery(GET_TASKS_STATUS, get_task_status_apicall);
  yield takeEvery(GET_TASKS_TYPE, get_task_type_apicall);
  yield takeEvery(GET_TASKS_DETAIL as unknown as TakeableChannel<unknown>, get_task_detail_apicall);
  yield takeEvery(DELETE_TASKS as unknown as TakeableChannel<unknown>, delete_task_apicall);
  yield takeEvery(APPROVE_TASKS as unknown as TakeableChannel<unknown>, approve_task_apicall);
  yield takeEvery(GET_REVIEW_ALL_DATA as unknown as TakeableChannel<unknown>, get_review_alldata_apicall);
  yield takeEvery(GET_NEED_REVIEW_ALL_DATA as unknown as TakeableChannel<unknown>, get_review_needdata_apicall);
  yield takeEvery(CHANGE_REVIEW_STATUS as unknown as TakeableChannel<unknown>, change_review_status_apicall);
  yield takeEvery(GET_USER_LIST as unknown as TakeableChannel<unknown>, get_userList_apicall);
  yield takeEvery(GET_USER_DETAIL as unknown as TakeableChannel<unknown>, get_userDetail_apicall);
  yield takeEvery(GET_USER_ROLES, get_userRole_apicall);
  yield takeEvery(GET_USER_ROLE_LIST, get_userRoleList_apicall);

  yield takeEvery(GET_USER_QUESTION_BANK as unknown as TakeableChannel<unknown>, get_userQuestionBank_apicall);
  yield takeEvery(GET_ADD_USER as unknown as TakeableChannel<unknown>, get_AddUser_apicall);
  yield takeEvery(EDIT_USER_DETAIL as unknown as TakeableChannel<unknown>, editUserDetail_apicall);
  yield takeEvery(GET_ORGANISATION_LIST as unknown as TakeableChannel<unknown>, getOraganisationList_apicall);
  yield takeEvery(
    GET_ORGANISATION_DROPDOWNLIST as unknown as TakeableChannel<unknown>,
    getOraganisationDropdownList_apicall
  );
  yield takeEvery(GET_ORGANISATION_DETAIL, getOraganisationDetail_apicall);
  yield takeEvery(GET_CATEGORY_LIST as unknown as TakeableChannel<unknown>, getCategoryListList_apicall);
  yield takeEvery(
    GET_CATEGORY_LIST_PAGINATION as unknown as TakeableChannel<unknown>,
    getCategoryListPaginationApicall
  );
  yield takeEvery(
    GET_QUESTIONBANK_LIST as unknown as TakeableChannel<unknown>,
    getQuestionBankListWithPermisson_apicall
  );
  yield takeEvery(GET_IDENTIFIER_LIST as unknown as TakeableChannel<unknown>, getIdentifierListList_apicall);
  yield takeEvery(GET_LOD_LIST as unknown as TakeableChannel<unknown>, getLodListList_apicall);
  yield takeEvery(GET_SUBJECT_PIPELINE_LIST as unknown as TakeableChannel<unknown>, getSubjectPipelineListList_apicall);
  yield takeEvery(GET_QUESTION_BANK_LIST as unknown as TakeableChannel<unknown>, getQuestionBankListList_apicall);
  yield takeEvery(CREATE_TASK as unknown as TakeableChannel<unknown>, createTask_apicall);
  yield takeEvery(EDIT_TASK as unknown as TakeableChannel<unknown>, editTask_apicall);
  yield takeEvery(GET_TASK_OF_USER, getTaskofUser_apicall);
  yield takeEvery(
    GET_TASK_QUESTION_BANK_LIST as unknown as TakeableChannel<unknown>,
    getTask_QuestionBank_List_apicall
  );
  yield takeEvery(GET_TASK_VIEW_DETAIL_LIST as unknown as TakeableChannel<unknown>, getTask_ViewDetails_List_apicall);
  yield takeEvery(GET_PRODUCT_TYPE, getProductType_apicall);
  yield takeEvery(CREATE_TEST_BASIC_SETTING as unknown as TakeableChannel<unknown>, getNewTest_basic_setting_apicall);
  yield takeEvery(CREATE_TEST_SECTION as unknown as TakeableChannel<unknown>, getNewTest_Section_apicall);
  yield takeEvery(VALIDATE_SECTION_RULE as unknown as TakeableChannel<unknown>, validate_Section_Rule_apicall);
  yield takeEvery(GET_SECTION_RULE_LIST as unknown as TakeableChannel<unknown>, getSection_RuleList_apicall);
  yield takeEvery(DELETE_SECTION_RULE_LIST as unknown as TakeableChannel<unknown>, delete_Section_RuleList_apicall);
  yield takeEvery(PUBLISH_TEST, getNewTestPublish);
  yield takeEvery(GET_TEST_LISTING as unknown as TakeableChannel<unknown>, getTestCreationLists_apicall);
  yield takeEvery(DELETE_TEST as unknown as TakeableChannel<unknown>, delete_test_apicall);
  yield takeEvery(UNPUBLISH_TEST as unknown as TakeableChannel<unknown>, unpublish_test_apicall);
  yield takeEvery(PUBLISHED_TEST as unknown as TakeableChannel<unknown>, publish_test_apicall);

  yield takeEvery(DUPLICATE_TEST as unknown as TakeableChannel<unknown>, duplicate_test_apicall);
  yield takeEvery(GET_VIEW_REPORT_LIST as unknown as TakeableChannel<unknown>, get_View_Report_List_apicall);
  yield takeEvery(CREATE_ACTIVITY_REQUEST as unknown as TakeableChannel<unknown>, createActivitySaga_apicall);
  yield takeEvery(RECENT_ACTIVITY_REQUEST as unknown as TakeableChannel<unknown>, recentActivitySaga_apicall);
  yield takeEvery(FETCH_ACTIVITY_REQUEST as unknown as TakeableChannel<unknown>, fetchActivitySaga_apicall);
  yield takeEvery(GET_REPORT_DETAIL_LIST as unknown as TakeableChannel<unknown>, get_ReportDetailList_apicall);
  yield takeEvery(GET_REPORT_QUESTION_BANK as unknown as TakeableChannel<unknown>, get_reportQuestionBank_apicall);
  yield takeEvery(GET_SUBJECT_TAGS, getProductsType_apicall);
  yield takeEvery(PRODUCT_TYPE, getProductsType_apicall);

  yield takeEvery(GET_TEST_DETAILS as unknown as TakeableChannel<unknown>, get_TestDetails_apicall);
  yield takeEvery(GET_REPLACE_QUESTION as unknown as TakeableChannel<unknown>, get_Replace_apicall);

  yield takeEvery(GET_TETS_DETAILS_FOR_EDIT as unknown as TakeableChannel<unknown>, get_TestDetails_for_edit_apicall);

  yield takeEvery(UPDATE_BASIC_SETTINGS as unknown as TakeableChannel<unknown>, editTest_basic_setting_apicall);
  yield takeEvery(EDIT_CREATE_TEST_SECTION as unknown as TakeableChannel<unknown>, geteditTest_Section_apicall);
}

export default IMS_AUTHORING_SAGA;
